import { eachDayOfInterval } from "date-fns";

import { middleOfDay } from "./middleOfDay";

export const eachUtcDayWithinRange = (...args: Parameters<typeof eachDayOfInterval>) =>
  eachDayOfInterval(...args).map(middleOfDay);
